import styled from 'styled-components/native';

export default styled.TouchableOpacity<{ ml?: number }>`
  align-items: center;
  flex-direction: row;
  margin-left: ${({ ml }) => ml || 0}px;
`;
